import React from "react";
import "./orderTable.css";
import styled from "@emotion/styled";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    maxWidth: "45rem",
    height: "25rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const OrdersTable = ({ maxWidth = "75rem", header, tableData = [], total }) => {
  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table text-nowrap">
          <tr className="table-rows">
            <th className="order-table-heads color_262c3d" width={"10%"}>
              Product Name
            </th>
            <th className="order-table-heads color_262c3d" width={"10%"}>
              Distributors
            </th>
            <th className="order-table-heads color_262c3d" width={"8%"}>
              Qty
            </th>
            <th className="order-table-heads" width={"8%"}>
              PTR
            </th>
            <th className="order-table-heads" width={"8%"}>
              Offer
            </th>
            <th className="order-table-heads" width={"8%"}>
              Net Price
            </th>
            <th className="order-table-heads" width={"8%"}>
              Free Qnty
            </th>
            <th className="order-table-heads" width={"8%"}>
              Discount(%)
            </th>
            <th className="order-table-heads color_262c3d" width={"8%"}>
              Price
            </th>
          </tr>
          {tableData.length > 0 &&
            tableData.map((ele, index) => (
              <tr className="table-rows1" key={index}>
                <td className="order-table-each-row-data">
                  {ele?.product?.product_name}
                </td>
                <td className="order-table-each-row-data">
                  {ele?.distributor?.firm_name}
                </td>
                <td className="order-table-each-row-data">{ele?.quantity}</td>
                <td className="order-table-each-row-data">₹ {ele?.ptr}</td>
                <td className="order-table-each-row-data">
                  {ele?.offer_type == "price" ? (
                    <label>₹ {ele?.offer}</label>
                  ) : (
                    "--"
                  )}
                </td>
                <td className="order-table-each-row-data">
                  {ele?.offer_type == "price" ? (
                    <label>₹ {ele?.ptr - ele?.offer}</label>
                  ) : (
                    "--"
                  )}
                </td>
                <td className="order-table-each-row-data">
                  {ele?.offer_type == "quantity" ? ele?.offer_qty : "--"}
                </td>
                <td className="order-table-each-row-data">
                  {ele?.offer_type == "discount" ? (
                    <label>{ele?.offer} %</label>
                  ) : (
                    "--"
                  )}
                </td>
                <td className="order-table-each-row-data">
                  ₹ {parseFloat(ele?.price).toFixed(2)}
                </td>
              </tr>
            ))}
        </table>
      </TableContainer>
      <TableFooter
        className="d-flex justify-content-between align-items-center px-4 table-footer"
        maxWidth={maxWidth}
      >
        <div>
          <label className="text-white ">Total</label>
        </div>
        <div>
          <label className="text-white fw_600 mx-5">
            ₹ {parseFloat(total).toFixed(2)}
          </label>
        </div>
      </TableFooter>
    </div>
  );
};

export default OrdersTable;
